import React from "react";
import styled from "styled-components";
import { Flex, Link, Button } from "../../components";

function callbackToNative(msg){
    try {
        console.log('calling back native')
      if (window.webkit != undefined) {
        window.webkit.messageHandlers.observe.postMessage(msg);
        window.webkit.messageHandlers.appInterface.postMessage(msg)
      }
      if (window.appInterface != undefined) {
          window.appInterface.postMessage(msg)
      }
    } catch (error) {
      console.log(msg);
      console(error);
    }
  }

  const RecruitmentTest = ({ search, practice_name, test_img, timelimit, description, results }) => (
    <div style={{padding:'50px'}}>
        <div>      
        <Flex column center>
            <div style={{ position: 'fixed', top: '0', paddingTop: '20px', left: '20px', background: '#f6f6f6', width: '100%', cursor: 'pointer'}}>
                <img onClick={()=>callbackToNative('done')} src="/images/back.svg"></img>
            </div>
            <h3>No Questions for this test </h3>
        </Flex>
        </div>
    </div>    
  );
  
  export default RecruitmentTest;